import { registerBlockType } from "@wordpress/blocks";
import metadata from "./block.json";
import "./style.scss";
import Edit from "./Edit";
import Save from "./save";

registerBlockType(metadata.name, {
  edit: Edit,
  save: Save,
  icon: {
    foreground: "#0061FE",
    src: (
      <svg
        id="a"
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
      >
        <path
          d="m15.5,9.8H7.5c-.4,0-.7-.4-.7-.8s.3-.8.8-.8h8c.4,0,.8.3.8.8s-.5.8-.9.8Z"
          stroke-width="0"
        />
        <path
          d="m15.5,12.8H7.5c-.4,0-.8-.3-.8-.8s.3-.8.8-.8h8c.4,0,.8.3.8.8s-.4.8-.8.8Z"
          stroke-width="0"
        />
        <path
          d="m11.5,15.8h-4c-.4,0-.8-.3-.8-.8s.3-.8.8-.8h4c.4,0,.8.3.8.8s-.4.8-.8.8Z"
          stroke-width="0"
        />
        <path
          d="m12,22.8c-.2,0-.4-.1-.5-.2l-1.8-1.8h-1.7c-3.2,0-5.8-2.5-5.8-5.8v-7c0-3.2,2.5-5.8,5.8-5.8h8c3.2,0,5.8,2.5,5.8,5.8v7c0,3.2-2.5,5.8-5.8,5.8h-1.7l-1.8,1.8c-.1.1-.3.2-.5.2ZM8,3.8c-2.4,0-4.2,1.8-4.2,4.2v7c0,2.4,1.9,4.2,4.2,4.2h2c.2,0,.4.1.5.2l1.5,1.5,1.5-1.5c.1-.1.3-.2.5-.2h2c2.4,0,4.2-1.9,4.2-4.2v-7c0-2.4-1.9-4.2-4.2-4.2,0,0-8,0-8,0Z"
          stroke-width="0"
        />
      </svg>
    ),
  },
});
